
import { defineComponent } from 'vue'
import Preview from '../components/meet/PreviewProva.vue'
import vuewebrtc from '../components/meet/vue-webrtc.vue'
import { isSupported } from 'twilio-video'
import dayjs from 'dayjs'
import { goapi } from '../api'
import { EventBus } from '@/event-bus'
import i18n from '@/i18n'

dayjs.locale(i18n.locale)

interface Participant {
	partecipantName: string
	twilioToken?: string
}

interface MeetData {
	loading: boolean
	twilioToken: string | null
	isSupported: boolean
	meetJoined: boolean
	roomId: string
	date: string | null
	deadline: string | null
}

export default defineComponent({
	name: 'MeetView',

	components: {
		preview: Preview,
		meet: vuewebrtc
	},

	data(): MeetData {
		return {
			loading: true,
			twilioToken: null,
			isSupported: isSupported,
			meetJoined: false,
			roomId: '',
			date: null,
			deadline: null
		}
	},

	async created(): Promise<void> {
		this.roomId = this.getMeetKey()
	},

	mounted(): void {
		this.loading = false
	},

	beforeDestroy(): void {
		if (this.meetJoined) {
			EventBus.$emit('meetJoined', false)
		}
	},

	methods: {
		/**
		 * Extract the meet key from the current URL
		 * @returns The meet key/ID
		 */
		getMeetKey(): string {
			return window.location.href.split('meet/').pop()?.split('?')[0] || ''
		},

		/**
		 * Handle participant joining the meet
		 * @param participant - The participant data
		 */
		async onJoin(participant: Participant): Promise<void> {
			console.log('onJoin called with participant:', participant.partecipantName)

			try {
				const response = await goapi.post<{ token: string }>('/twilio-auth', {
					roomName: this.roomId,
					identity: participant.partecipantName
				})

				console.log('Twilio auth response:', response.data)

				participant.twilioToken = response.data.token
				console.log('Twilio token obtained for:', participant.partecipantName)
			} catch (error) {
				console.error('Error calling Twilio auth:', error)
				return
			}

			this.meetJoined = !this.meetJoined

			// Emit event to hide header in App.vue
			EventBus.$emit('meetJoined', this.meetJoined)

			this.$nextTick(() => {
				const meetRef = this.$refs.meet as any
				if (meetRef) {
					meetRef.join(participant)

					// Trigger dimensions calculation after component is mounted
					setTimeout(() => {
						if (meetRef.dimensions) {
							meetRef.dimensions()
							console.log('Dimensions triggered from Meet.vue')
						}
					}, 200)
				}
			})
		}
	}
})
